export const PXLoginRegister = (function () {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
